<template lang="pug">
.t-content
  section.info-sec
    .max-container
      .reviews
        statisticsData(ref="board")
        reviewDisplay  
</template>
<script>
import topbar from '@/views/default/_topBar.vue'
import tabs from '@/views/default/_tabs.vue'
import statisticsData from '@/components2/_statisticsData.vue'
import reviewDisplay from '@/components2/_reviewDisplay.vue'
import _ from "lodash";
export default {
  // metaInfo:{
  //   title: 'Players Review | EpicWin Online Casino',
  //   meta:[
  //     {vmid: "description",name: 'description', content: "Read reviews from players about EpicWin. Learn about their experiences, favorite games, and why they choose to play at EpicWin."}
  //   ],
  // },
  components:{
    topbar,
    tabs,
    statisticsData,
    reviewDisplay
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      metaData: []
    }
  },
  // metaInfo(){
  //   if(this.metaData.length> 0){
  //     return{
  //       title: this.metaData[0].meta_title || 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: this.metaData[0].meta_desc },
  //         { name: "keywords", content: this.metaData[0].meta_keywords },
  //         { name: "author", content: this.metaData[0].meta_author },
  //         { name: "publisher", content: this.metaData[0].meta_publisher },

  //         { property: 'og:title', content: this.metaData[0].meta_title },
  //         { property: 'og:description', content: this.metaData[0].meta_desc },
          
  //       ],
  //       link: [
  //         { rel: 'canonical', href: this.metaData[0].meta_canonical }, // Sets the canonical URL
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: 'EpicWin Malaysia',
  //       meta:[
  //         { name: 'description',content: 'EpicWin Malaysia' },
  //       ],
  //     }
  //   }
  // },
  created(){
    // this.checkSize()
    // $('link[rel="canonical"]').attr('href', 'https://www.epicwin.app/reviews');
  },
  mounted(){
    var vm = this
    // $(window).resize(function () {
    //   vm.checkSize()
    // });
		if(!_.isEmpty(this.$route.params)){
      if(this.$route.params.leaderboard == true){
				this.scrolltoView()
			}
    }
    // this.getSeo()
    window.scroll(0,0)
  },
  methods:{
    getSeo(){			
      var temp = window.location.pathname.split("/")
      let page_name = temp[temp.length-1]
      let domain_name = window.location.hostname
			this.$store
				.dispatch("user/getSeo", {page_name, domain_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
              this.metaData = response.data
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}       
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
    checkSize(){
      if ($(window).width() < 681) {
        this.showMobile = true
      }else{
        this.showMobile = false
      }
    },
    scrolltoView(){
      this.$refs.board.scrollToTarget()
    }
  }
}
</script>